import { loadDatadog } from './dataDog/index';
import { loadFitAnalyticsScript } from './fitAnalytics/index';
import { loadGoogleAdScript } from './googleAds/googleAds';
import { loadSurveyScript } from './survey/medallia';

export const loadExternalDependencies = async () => {
  loadSurveyScript();
  loadDatadog();
  loadFitAnalyticsScript();
  loadGoogleAdScript();
};
